module.exports = __webpack_public_path__ + "img/bb_g3_t_antenna-06.bc903061.svg";